export default {"src":"https://cdn.wedding-spot.com/_next/static/media/rings.051c4d1a.svg","height":95,"width":115};